'use client'

import styled from "styled-components";

export const LanguageSelectStyled = styled.div`
    padding-left: 0 !important;
    width: fit-content !important;
    
    .ant-select-selector {
        padding: 0 5px !important;

        &:hover, &:focus, &:active, &:focus-within, &:focus-visible {
            border: none !important;
        }

        span svg {
            padding-right: 0 !important;
            width: 100%;
        }
    }

    .rc-virtual-list-holder-inner {
        padding: 0 !important;
        
        .ant-select-item {
            padding: 0 !important;
        }
    }
    
`